var map = {
	"./DB1.webp": 6150,
	"./DB2.webp": 6583,
	"./DB3.webp": 3988,
	"./DB4.webp": 5669,
	"./DB5.webp": 1402,
	"./DB6.webp": 3291,
	"./DB7.webp": 5912,
	"./DB8.webp": 9609,
	"./aguri-homepage.png": 3926,
	"./aguri-mockup.png": 4767,
	"./buy1.webp": 9310,
	"./buy2.webp": 2255,
	"./buy3.webp": 1388,
	"./buy4.webp": 3565,
	"./buy5.webp": 2226,
	"./buy6.png": 4179,
	"./cate.webp": 6614,
	"./home.webp": 3982,
	"./intro-01.webp": 3891,
	"./jewelry-bg.png": 7799,
	"./line1-02.png": 699,
	"./line1-02.webp": 7531,
	"./line1-center.png": 3962,
	"./line1-center.webp": 5416,
	"./line2-01.png": 2933,
	"./line2-02.webp": 4004,
	"./line3-02.png": 3633,
	"./line3-02.webp": 6873,
	"./line7.png": 4072,
	"./logo.svg": 334,
	"./mockup.png": 7556,
	"./mockupp1.png": 5490,
	"./mockupp2.png": 1310,
	"./mockupp3.png": 4327,
	"./mockupp4.png": 2808,
	"./phone-bg.png": 9453,
	"./phone2-bg.png": 9391,
	"./product-page.png": 9434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3109;